module.exports = __webpack_public_path__ + "static/fipcpastelfloral1-c90f72e008d5e9fbcca4bb39187b4838.jpeg";